import Meta from "@/components/meta";
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import { startCase } from "lodash";

const Logo = ({ name }: { name: string }) => {
  const url = `/logos/${name}`;
  return (
    <li role="listitem" className={name.includes("white") ? "bg-dark" : ""}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={url + ".svg"}
        style={{
          width: "100%",
          height: name.includes("vertical") ? 128 : 96,
        }}
        alt={startCase(name)}
      />
      <h2>{startCase(name).replace("Bw", " B & W")}</h2>
      <div className="links">
        <a className="" href={url + ".svg"}>
          SVG
        </a>
        <a className="" href={url + ".png"}>
          PNG
        </a>
      </div>
      <style jsx>{`
        li {
          margin: 0;
          padding: 0;
          text-align: center;
        }
        img {
          border-radius: 12px;
          padding: 12px;
        }
        .bg-dark img {
          background-color: #182342;
        }
        h2 {
          margin-top: 16px;
          font-size: 18px;
        }
        .links {
          display: flex;
          justify-content: center;
          gap: 32px;
        }
      `}</style>
    </li>
  );
};

export default function LogosPage() {
  return (
    <>
      <Meta
        title="Logos"
        description="View & download Watershed’s branding & logos."
      />
      <Navbar />
      <main>
        <article className="blog-post">
          <h1>Logos</h1>
          <ul>
            {[
              "horizontal-lockup-dark",
              "horizontal-lockup-white",
              "horizontal-lockup-bw",
              "vertical-lockup-dark",
              "vertical-lockup-white",
              "vertical-lockup-bw",
              "mark",
            ].map((key) => (
              <Logo name={key} key={key} />
            ))}
          </ul>
          <style jsx>{`
            h1 {
              text-align: center;
              margin-bottom: 48px;
            }
            ul {
              list-style: none;
              display: grid;
              grid-gap: 48px 24px;
              margin: 0;
              padding: 0;
            }
            @media (min-width: 820px) {
              h1 {
                font-size: 48px;
              }
              ul {
                grid-template-columns: repeat(3, minmax(0, 1fr));
              }
            }
          `}</style>
        </article>
      </main>
      <Footer />
    </>
  );
}
